import OrganizationModal from './OrganizationModal'

export default OrganizationModal
